(function () {
  const DATA_ELEMENT_ID = 'RughausAnalyticsData';
  const CART_UPDATE_EVENT = 'cart:update';
  const trackedCheckoutClicks = new WeakSet();

  const readConfig = () => {
    const element = document.getElementById(DATA_ELEMENT_ID);
    if (!element?.textContent) return {};

    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      console.warn('RUGHAUS analytics config could not be parsed.', error);
      return {};
    }
  };

  const config = readConfig();
  let currentCart = config.cart || null;

  window.dataLayer = window.dataLayer || [];

  const centsToAmount = (value) => {
    const amount = Number(value);
    if (!Number.isFinite(amount)) return undefined;

    return amount / 100;
  };

  const clean = (payload) =>
    Object.fromEntries(
      Object.entries(payload).filter(([, value]) => value !== undefined && value !== null && value !== '')
    );

  const buildBasePayload = () =>
    clean({
      page_type: config.pageType,
      template: config.template,
      template_suffix: config.templateSuffix,
      language: config.locale,
      currency: config.currency,
      page_location: window.location.href,
      page_path: window.location.pathname,
      canonical_url: config.canonicalUrl,
    });

  const pushEvent = (eventName, payload = {}) => {
    const eventPayload = clean({
      event: eventName,
      rughaus_event: true,
      ...buildBasePayload(),
      ...payload,
    });

    window.dataLayer.push(eventPayload);
    window.dispatchEvent(new CustomEvent('rughaus:analytics', { detail: eventPayload }));
  };

  const mapItem = (item, quantityOverride) => {
    if (!item) return undefined;

    const quantity = Number(quantityOverride ?? item.quantity ?? 1);
    const price = centsToAmount(item.price ?? item.final_price);

    return clean({
      item_id: String(item.variantId ?? item.variant_id ?? item.id ?? ''),
      item_name: item.title || item.product_title || item.productTitle,
      item_variant: item.variantTitle || item.variant_title || item.variant?.title,
      item_sku: item.sku,
      item_product_id: String(item.productId ?? item.product_id ?? ''),
      price,
      quantity: Number.isFinite(quantity) ? quantity : 1,
    });
  };

  const findCartItem = (cart, variantId) => {
    if (!cart?.items || !variantId) return undefined;

    return cart.items.find((item) => String(item.variantId ?? item.variant_id) === String(variantId));
  };

  const trackPageViews = () => {
    pushEvent('page_view');

    if (config.collection) {
      pushEvent('collection_view', {
        collection_id: String(config.collection.id),
        collection_handle: config.collection.handle,
        collection_name: config.collection.title,
        item_count: config.collection.productCount,
      });
    }

    if (config.product) {
      const item = mapItem({
        productId: config.product.id,
        variantId: config.product.variantId,
        sku: config.product.sku,
        title: config.product.title,
        variantTitle: config.product.variantTitle,
        price: config.product.price,
        quantity: 1,
      });

      pushEvent('product_view', {
        product_id: String(config.product.id),
        product_handle: config.product.handle,
        product_name: config.product.title,
        product_type: config.product.type,
        product_vendor: config.product.vendor,
        variant_id: String(config.product.variantId),
        value: item?.price,
        items: item ? [item] : undefined,
      });
    }
  };

  const trackAddToCart = (event) => {
    const detail = event.detail || {};
    const data = detail.data || {};

    if (data.didError || data.source !== 'product-form-component') return;

    const variantId = detail.sourceId || data.variantId;
    const cartItem = findCartItem(detail.resource, variantId);
    const quantity = Number(data.itemCount || cartItem?.quantity || 1);
    const item = mapItem(cartItem || { variantId, productId: data.productId }, quantity);

    currentCart = detail.resource || currentCart;

    pushEvent('add_to_cart', {
      product_id: data.productId ? String(data.productId) : item?.item_product_id,
      variant_id: variantId ? String(variantId) : item?.item_id,
      value: item?.price !== undefined ? item.price * (item.quantity || 1) : undefined,
      items: item ? [item] : undefined,
    });
  };

  const trackBeginCheckout = (trigger) => {
    const cart = currentCart || config.cart;
    const items = Array.isArray(cart?.items) ? cart.items.map((item) => mapItem(item)).filter(Boolean) : [];

    pushEvent('begin_checkout', {
      trigger,
      value: centsToAmount(cart?.totalPrice ?? cart?.total_price),
      item_count: cart?.itemCount ?? cart?.item_count,
      items,
    });
  };

  const onCheckoutIntent = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const checkoutButton = target?.closest('button[name="checkout"], #checkout, a[href*="/checkout"]');

    if (!checkoutButton || trackedCheckoutClicks.has(checkoutButton)) return;

    trackedCheckoutClicks.add(checkoutButton);
    trackBeginCheckout(checkoutButton.id || checkoutButton.getAttribute('name') || 'checkout');
  };

  document.addEventListener(CART_UPDATE_EVENT, trackAddToCart);
  document.addEventListener('click', onCheckoutIntent, true);
  document.addEventListener('submit', onCheckoutIntent, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackPageViews, { once: true });
  } else {
    trackPageViews();
  }
})();
